
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  on: {
    pageBeforeRemove(e, page) {
      var $page = this.$$(page.el);
      $page.off('click');
      $page.off('submit');
      $page.off('change');
    },
    pageInit(e, page) {
      const app = this.$app;
      const $$ = this.$;
      var $page = $$(page.el);
      var toastBottom = app.toast.create({
        text: 'Doctor not available on this date',
        position: 'center',
        closeTimeout: 2000
      });
      var doctorPage = page.route.context.pageId;
      function updateActionTotal() {
        var totalText = $page.find('#amntdetail .totalAmnt').text();
        if (totalText)
          $page.find('.bk-action-total-value').text(totalText);
      }
      $page.on('click', '.bk-date-tile', function (ev) {
        var $tile = $$(this);
        if ($tile.hasClass('inactive')) {
          $page.find('.bk-date-tile').removeClass('active');
          $page.find('#slotTimeArea').html('');
          $page.find('#doctorBookingDate').val('');
          toastBottom.open();
          return;
        }
        $page.find('.bk-date-tile').removeClass('active');
        $tile.addClass('active');
        var day = $tile.data('myday');
        var fullDate = $tile.data('fullDate');
        var doctor = page.route.context.data.id;
        $page.find('#doctorBookingDate').val(fullDate);
        app.methods.authHeader();
        app.request({
          url: app.data.remoteUrl + 'doctors/' + doctor + '/slots?date=' + fullDate,
          method: 'GET',
          dataType: 'json',
          success: function (returndata) {
            var slots = [];
            if (returndata && returndata.data && returndata.data.slots && returndata.data.slots.length > 0) {
              slots = returndata.data.slots;
            } else if (returndata && returndata.data && Array.isArray(returndata.data) && returndata.data.length > 0) {
              slots = returndata.data;
            } else if (returndata && returndata.slots && returndata.slots.length > 0) {
              slots = returndata.slots;
            }
            var html = '';
            if (slots.length > 0) {
              slots.forEach(function (slot, index) {
                var activeClass = index === 0 ? ' active' : '';
                var slotText = typeof slot === 'object' ? slot.display || slot.start_time + ' - ' + slot.end_time : slot;
                html += '<div class="col-50"><li class="slotTimeSection bk-slot' + activeClass + '">' + slotText + '</li></div>';
              });
            } else {
              html = '<div class="col-50" style="width:100%"><p style="text-align:center;color:var(--mdoc-muted);font-size:12.5px;padding:8px 0;">No slots available for this date</p></div>';
            }
            $page.find('#slotTimeArea').html(html);
            var doctorBookingTime = $page.find('.slotTimeSection.active').text();
            $page.find('#doctorBookingTime').val(doctorBookingTime);
          },
          complete: function () {
            app.preloader.hide();
          },
          error: function (xhr) {
            app.preloader.hide();
            try {
              var errData = JSON.parse(xhr.responseText || xhr.response);
              if (errData && errData.msg) {
                app.dialog.alert(errData.msg, 'Error');
                return;
              }
            } catch (er) {
            }
            app.methods.requestError(xhr);
          },
          beforeSend: function () {
            app.preloader.show();
          }
        });
      });
      $page.on('click', '.slotTimeSection', function () {
        $page.find('.slotTimeSection').removeClass('active');
        $$(this).addClass('active');
        $page.find('#doctorBookingTime').val($$(this).text());
      });
      $page.on('change', '#appointment_type input[type="radio"][name="type"]', function () {
        var apptype = $$(this).val();
        var doctor = page.route.context.data.id;
        app.views.main.router.navigate('/booking/' + doctor + '/' + apptype);
      });
      $page.on('click', '.rmv_btn', function () {
        setTimeout(function () {
          var t = $page.find('#amntdetail .totalAmnt').text();
          if (t)
            $page.find('.bk-action-total-value').text(t);
        }, 0);
      });
      $page.on('click', '#bkPayBtn', function () {
        $page.find('#enpBooking').trigger('submit');
      });
      $page.on('submit', '#enpBooking', function (ev) {
        ev.preventDefault();
        var formData = app.form.convertToData('#' + doctorPage + ' #enpBooking');
        app.methods.authHeader();
        app.preloader.show();
        var playerID = localStorage.getItem('playerID') || '';
        app.request({
          url: app.data.remoteUrl + 'bookings',
          method: 'POST',
          data: {
            doctor_id: formData.doctor,
            date: formData.date,
            time: formData.time,
            patient_name: formData.name,
            patient_age: formData.age,
            patient_gender: formData.gender,
            mobile: formData.mobile,
            address: formData.address,
            type: formData.type,
            coupon_code: formData.coupon,
            patient_id: formData.patinet,
            one_signal_id: playerID
          },
          dataType: 'json',
          success: function (returnData) {
            app.preloader.hide();
            if (returnData['status']) {
              if (app.methods.invalidateHomeCache) {
                app.methods.invalidateHomeCache();
              }
              var resData = returnData['data'] || returnData;
              var bookId = resData['booking_id'] || resData['book_id'];
              if (resData['requires_payment'] && bookId) {
                payment(bookId);
              } else {
                app.dialog.alert('Your booking is confirmed!', 'mDOC', function () {
                  app.views.main.router.navigate('/appointment/', { reloadAll: true });
                });
              }
            } else {
              app.dialog.alert(returnData['msg'] || 'Booking failed.', 'Error');
            }
          },
          error: function (xhr) {
            app.preloader.hide();
            try {
              var errData = JSON.parse(xhr.responseText || xhr.response);
              if (errData && errData.msg) {
                app.dialog.alert(errData.msg, 'Error');
                return;
              }
            } catch (er) {
            }
            app.methods.requestError(xhr);
          }
        });
      });
      function payment(bookId) {
        app.methods.authHeader();
        app.preloader.show();
        app.request({
          url: app.data.remoteUrl + 'payments/initiate',
          method: 'POST',
          data: {
            type: 'booking',
            booking_id: bookId
          },
          dataType: 'json',
          success: function (response) {
            app.preloader.hide();
            if (response.status && response.data) {
              response.data.description = 'Doctor Appointment Booking';
              app.methods.razorpayCheckout(response.data, {
                onSuccess: function () {
                  app.dialog.alert('Payment successful! Your booking is confirmed.', 'mDOC', function () {
                    app.views.main.router.navigate('/appointment/', { reloadAll: true });
                  });
                },
                onDismiss: function () {
                  app.views.main.router.navigate('/appointment/', { reloadAll: true });
                }
              });
            } else {
              app.dialog.alert(response.msg || 'Payment initiation failed. You can pay later from appointments.', 'mDOC', function () {
                app.views.main.router.navigate('/appointment/', { reloadAll: true });
              });
            }
          },
          error: function (xhr) {
            app.preloader.hide();
            var msg = 'Payment initiation failed. You can pay later from appointments.';
            try {
              var errData = JSON.parse(xhr.responseText || xhr.response);
              if (errData && errData.msg)
                msg = errData.msg;
            } catch (er) {
            }
            app.dialog.alert(msg, 'mDOC', function () {
              app.views.main.router.navigate('/appointment/', { reloadAll: true });
            });
          }
        });
      }
    }
  },
  id: 'cddde27bc7',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page booking-form-page" data-name="';
      r += c(ctx_1.pageId, ctx_1);
      r += '" id="';
      r += c(ctx_1.pageId, ctx_1);
      r += '" data-ignore-cache="true" removeElements=\'true\' router.off=\'on\'>\n        <div class="navbar">\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="#" class="link back" aria-label="Back">\n                        <i class="icon icon-back"></i>\n                    </a>\n                </div>\n                <div class="title">Book Appointment</div>\n            </div>\n        </div>\n        <div class="page-content">\n            <form id="enpBooking" class="bk-form">\n                <input type="hidden" name="doctor" value="';
      r += c(ctx_1.doctorId, ctx_1);
      r += '">\n                <input type="hidden" name="date"   value="';
      r += c(ctx_1.defaultDate, ctx_1);
      r += '" id="doctorBookingDate">\n                <input type="hidden" name="time"   value="';
      r += c(ctx_1.defaultTime, ctx_1);
      r += '" id="doctorBookingTime">\n                <input type="hidden" name="coupon" value="';
      r += Template7Helpers.if.call(ctx_1, ctx_1.data.isPromoCouponApplyed, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += c(ctx_2.data.coupon.code, ctx_2);
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '" id="bookingCoupon">\n\n                <!-- Doctor hero card -->\n                <div class="bk-doctor-card">\n                    <div class="bk-doctor-blob"></div>\n                    <div class="bk-doctor-photo">\n                        <img src="';
      r += c(ctx_1.data.dp_url, ctx_1);
      r += '" alt="" onerror="this.src=\'static/img/default_doctor.svg\'">\n                    </div>\n                    <div class="bk-doctor-info">\n                        <div class="bk-doctor-name">Dr. ';
      r += c(ctx_1.data.name, ctx_1);
      r += '</div>\n                        ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.data.isPartnerDoctor == 1', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        <a href="#" class="doctor-verified-chip partner-info-btn" aria-label="mDOC Verified Partner \u2014 tap to learn more">\n                            <i class="icon f7-icons if-not-md doctor-verified-chip-seal">checkmark_seal_fill</i>\n                            <i class="icon material-icons md-only doctor-verified-chip-seal">verified</i>\n                            <span class="doctor-verified-chip-text">mDOC Verified</span>\n                        </a>\n                        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                        ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.data.degree, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        <div class="bk-doctor-degree">';
          r += c(ctx_2.data.degree, ctx_2);
          r += '</div>\n                        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                        ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.data.address, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        <div class="bk-doctor-address">\n                            <i class="icon f7-icons if-not-md">placemark_fill</i>\n                            <i class="icon material-icons md-only">place</i>\n                            <span>';
          r += c(ctx_2.data.address, ctx_2);
          r += '</span>\n                        </div>\n                        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                    </div>\n                </div>\n\n                <!-- Appointment Type (only when subscription option available) -->\n                ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.data.isActiveSubscription, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.data.isPartnerDoctor == 1', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                <section class="bk-section">\n                    <div class="bk-section-title">Appointment type</div>\n                    <div id="appointment_type" class="bk-type-row">\n                        <label class="bk-type-pill">\n                            <input type="radio" name="type" value="Normal" ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.type != \'Free\'', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += 'checked=""';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '>\n                            <span class="bk-type-pill-body">\n                                <span class="bk-type-pill-title">Normal</span>\n                                <span class="bk-type-pill-sub">Pay as you book</span>\n                            </span>\n                        </label>\n                        <label class="bk-type-pill">\n                            <input type="radio" name="type" value="Free" ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.type == \'Free\'', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += 'checked=""';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '>\n                            <span class="bk-type-pill-body">\n                                <span class="bk-type-pill-title">';
              r += c(ctx_3.data.appoitmentTypeLabel.free, ctx_3);
              r += '</span>\n                                <span class="bk-type-pill-sub">From your active plan</span>\n                            </span>\n                        </label>\n                    </div>\n                </section>\n                ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n                <div id="appointment_type" style="display: none;">\n                    <input type="radio" checked="" name="type" value="Normal">\n                </div>\n                ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <div id="appointment_type" style="display: none;">\n                    <input type="radio" checked="" name="type" value="Normal">\n                </div>\n                ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n                <!-- Date picker -->\n                <section class="bk-section">\n                    <div class="bk-section-header">\n                        <span class="bk-section-title">Select date</span>\n                    </div>\n                    <div class="bk-section-card bk-date-card">\n                        <div class="bk-date-scroll">\n                            <div data-space-between="10" data-slides-offset-before="0" data-slides-offset-after="8" data-slides-per-view="auto" data-free-mode="true" class="swiper-container swiper-init bk-date-swiper">\n                                <div class="swiper-wrapper">\n                                    ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.data.dates, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                                    <div data-myday="';
          r += c(ctx_2.myDay, ctx_2);
          r += '" data-fullDate="';
          r += c(ctx_2.fullDate, ctx_2);
          r += '" class="dateBtn swiper-slide bk-date-tile';
          r += Template7Helpers.if.call(ctx_2, ctx_2.is_active, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += ' active';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += Template7Helpers.unless.call(ctx_2, ctx_2.is_available, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += ' inactive';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '">\n                                        <div class="bk-date-tile-day">';
          r += c(ctx_2.day, ctx_2);
          r += '</div>\n                                        <div class="bk-date-tile-date">';
          r += c(ctx_2.date, ctx_2);
          r += '</div>\n                                        <div class="bk-date-tile-month">';
          r += c(ctx_2.month, ctx_2);
          r += '</div>\n                                    </div>\n                                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </section>\n\n                <!-- Time slots -->\n                <section class="bk-section">\n                    <div class="bk-section-header">\n                        <span class="bk-section-title">Select time slot</span>\n                    </div>\n                    <div class="bk-section-card bk-slots-card">\n                        <ul class="slots row bk-slot-grid" id="slotTimeArea">\n                            ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.data.slot, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                            <div class="col-50">\n                                <li class="slotTimeSection bk-slot';
          r += Template7Helpers.if.call(ctx_2, data_2 && data_2.first, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += ' active';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '">';
          r += c(ctx_2, ctx_2);
          r += '</li>\n                            </div>\n                            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                        </ul>\n                    </div>\n                </section>\n\n                <!-- Patient details / picker -->\n                <section class="bk-section">\n                    <div class="bk-section-header">\n                        <span class="bk-section-title">Patient details</span>\n                        ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.type == \'Normal\'', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        <span class="bk-section-optional">All fields required</span>\n                        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                    </div>\n                    <div class="bk-section-card bk-patient-card">\n                        ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.type == \'Normal\'', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        <div class="pl-form bk-patient-form">\n                            <div class="pl-form-field">\n                                <label class="pl-form-label" for="bkPatientName">\n                                    <span>Name</span>\n                                    <span class="pl-form-required">*</span>\n                                </label>\n                                <input type="text" id="bkPatientName" name="name" placeholder="Patient name" required validate>\n                            </div>\n\n                            <div class="bk-form-row">\n                                <div class="pl-form-field">\n                                    <label class="pl-form-label" for="bkPatientAge">\n                                        <span>Age</span>\n                                        <span class="pl-form-required">*</span>\n                                    </label>\n                                    <input type="number" id="bkPatientAge" name="age" placeholder="Years" pattern="[0-9]*" inputmode="numeric" required validate>\n                                </div>\n                                <div class="pl-form-field">\n                                    <label class="pl-form-label" for="bkPatientMobile">\n                                        <span>Mobile</span>\n                                        <span class="pl-form-required">*</span>\n                                    </label>\n                                    <input type="tel" id="bkPatientMobile" name="mobile" placeholder="10 digits" maxlength="13" minlength="10" pattern="[0-9]*" inputmode="numeric" required validate data-error-message="Please enter valid mobile number">\n                                </div>\n                            </div>\n\n                            <div class="pl-form-field">\n                                <span class="pl-form-label">\n                                    <span>Gender</span>\n                                    <span class="pl-form-required">*</span>\n                                </span>\n                                <div class="pl-gender-row">\n                                    <label class="pl-gender-pill">\n                                        <input type="radio" checked="" name="gender" value="Male">\n                                        <span>Male</span>\n                                    </label>\n                                    <label class="pl-gender-pill">\n                                        <input type="radio" name="gender" value="Female">\n                                        <span>Female</span>\n                                    </label>\n                                    <label class="pl-gender-pill">\n                                        <input type="radio" name="gender" value="Other">\n                                        <span>Other</span>\n                                    </label>\n                                </div>\n                            </div>\n\n                            <div class="pl-form-field">\n                                <label class="pl-form-label" for="bkPatientAddress">\n                                    <span>Address</span>\n                                    <span class="pl-form-required">*</span>\n                                </label>\n                                <textarea id="bkPatientAddress" name="address" rows="2" placeholder="Patient address" required validate></textarea>\n                            </div>\n                        </div>\n                        ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        <div class="bk-patient-list">\n                            ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.data.patientList, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                            <label class="bk-patient-tile">\n                                <input type="radio" name="patinet" value="';
              r += c(ctx_3.id, ctx_3);
              r += '" ';
              r += Template7Helpers.if.call(ctx_3, data_3 && data_3.first, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += 'checked=""';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '>\n                                <span class="bk-patient-tile-radio"></span>\n                                <span class="bk-patient-tile-body">\n                                    <span class="bk-patient-tile-name">';
              r += c(ctx_3.name, ctx_3);
              r += '</span>\n                                    <span class="bk-patient-tile-meta">';
              r += c(ctx_3.gender, ctx_3);
              r += ' \xB7 ';
              r += c(ctx_3.age, ctx_3);
              r += ' yrs</span>\n                                </span>\n                            </label>\n                            ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                        </div>\n                        ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                    </div>\n                </section>\n\n                <!-- Coupon -->\n                <section class="bk-section">\n                    <div class="bk-section-header">\n                        <span class="bk-section-title">Coupon</span>\n                        <span class="bk-section-optional">Optional</span>\n                    </div>\n\n                    <a href="/applyCoupon/';
      r += c(ctx_1.data.id, ctx_1);
      r += '/" id="couponApplyBefor" class="bk-coupon-apply';
      r += Template7Helpers.if.call(ctx_1, ctx_1.data.isPromoCouponApplyed, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' bk-hidden';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '">\n                        <div class="bk-coupon-apply-icon">\n                            <i class="icon f7-icons if-not-md">tag_fill</i>\n                            <i class="icon material-icons md-only">local_offer</i>\n                        </div>\n                        <div class="bk-coupon-apply-body">\n                            <div class="bk-coupon-apply-title">Apply coupon</div>\n                            <div class="bk-coupon-apply-sub">Get extra savings on this booking</div>\n                        </div>\n                        <i class="icon f7-icons if-not-md bk-coupon-apply-arrow">chevron_right</i>\n                        <i class="icon material-icons md-only bk-coupon-apply-arrow">chevron_right</i>\n                    </a>\n\n                    <div id="couponApplyAfter" class="bk-coupon-applied';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.data.isPromoCouponApplyed, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' bk-hidden';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '">\n                        <div class="bk-coupon-applied-icon">\n                            <i class="icon f7-icons if-not-md">checkmark_seal_fill</i>\n                            <i class="icon material-icons md-only">verified</i>\n                        </div>\n                        <div class="bk-coupon-applied-body">\n                            <div class="bk-coupon-applied-code couponName">';
      r += c(ctx_1.data.coupon.code, ctx_1);
      r += '</div>\n                            <div class="bk-coupon-applied-saved">You saved \u20B9<span class="couponValueAmount">';
      r += c(ctx_1.data.coupon.couponAmount, ctx_1);
      r += '</span></div>\n                        </div>\n                        <span class="bk-coupon-applied-remove rmv_btn">Remove</span>\n                    </div>\n                </section>\n\n                <!-- Payment summary -->\n                ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.data.isPromoCouponApplyed, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <section class="bk-section" id="amntdetail">\n                    <div class="bk-section-header">\n                        <span class="bk-section-title">Payment details</span>\n                    </div>\n                    <div class="bk-section-card bk-payment-card">\n                        <div class="bk-payment-row">\n                            <span>Appointment fee</span>\n                            <span>\n                                ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.data.charge.fee == 0', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                <strike>\u20B9<span class="doctorFree" data-doctorFree="';
              r += c(ctx_3.data.charge.originalFee, ctx_3);
              r += '">';
              r += c(ctx_3.data.chargeWithCoupon.originalFee, ctx_3);
              r += '</span></strike><sup class="bk-fee-mark">*</sup>\n                                ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                \u20B9<span class="doctorFree" data-doctorFree="';
              r += c(ctx_3.data.charge.originalFee, ctx_3);
              r += '">';
              r += c(ctx_3.data.chargeWithCoupon.originalFee, ctx_3);
              r += '</span>\n                                ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                            </span>\n                        </div>\n                        <div class="bk-payment-row">\n                            <span>Service charge</span>\n                            <span>\u20B9<span class="serviceCharge" data-serviceCharge="';
          r += c(ctx_2.data.charge.serviceCharge, ctx_2);
          r += '">';
          r += c(ctx_2.data.chargeWithCoupon.serviceCharge, ctx_2);
          r += '</span></span>\n                        </div>\n                        <div class="bk-payment-row bk-payment-row-discount">\n                            <span>Coupon discount</span>\n                            <span>-\u20B9<span class="dscnt_amt" data-dscnt_amt="';
          r += c(ctx_2.data.charge.discountAmount, ctx_2);
          r += '">';
          r += c(ctx_2.data.chargeWithCoupon.discountAmount, ctx_2);
          r += '</span></span>\n                        </div>\n                        <div class="bk-payment-row" id="gst">\n                            <span>GST on service charge (';
          r += c(ctx_2.data.chargeWithCoupon.gstRate, ctx_2);
          r += '%)</span>\n                            <span>\u20B9<span class="gstAmount" data-gstAmount="';
          r += c(ctx_2.data.charge.gstAmount, ctx_2);
          r += '">';
          r += c(ctx_2.data.chargeWithCoupon.gstAmount, ctx_2);
          r += '</span></span>\n                        </div>\n                        <div class="bk-payment-total">\n                            <span>Total</span>\n                            <span class="bk-payment-total-value">\u20B9<span class="totalAmnt" data-totalAmnt="';
          r += c(ctx_2.data.charge.TotalCharge, ctx_2);
          r += '">';
          r += c(ctx_2.data.chargeWithCoupon.TotalCharge, ctx_2);
          r += '</span></span>\n                        </div>\n                        ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.data.charge.fee == 0', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                        <div class="bk-fee-note"><sup class="bk-fee-mark">*</sup> Appointment fee is payable at the doctor\'s clinic.</div>\n                        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                    </div>\n                </section>\n                ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <section class="bk-section" id="amntdetail">\n                    <div class="bk-section-header">\n                        <span class="bk-section-title">Payment details</span>\n                    </div>\n                    <div class="bk-section-card bk-payment-card">\n                        <div class="bk-payment-row">\n                            <span>Appointment fee</span>\n                            <span>\n                                ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.data.charge.fee == 0', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                <strike>\u20B9<span class="doctorFree" data-doctorFree="';
              r += c(ctx_3.data.charge.originalFee, ctx_3);
              r += '">';
              r += c(ctx_3.data.charge.originalFee, ctx_3);
              r += '</span></strike><sup class="bk-fee-mark">*</sup>\n                                ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                \u20B9<span class="doctorFree" data-doctorFree="';
              r += c(ctx_3.data.charge.originalFee, ctx_3);
              r += '">';
              r += c(ctx_3.data.charge.originalFee, ctx_3);
              r += '</span>\n                                ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                            </span>\n                        </div>\n                        <div class="bk-payment-row">\n                            <span>Service charge</span>\n                            <span>\u20B9<span class="serviceCharge" data-serviceCharge="';
          r += c(ctx_2.data.charge.serviceCharge, ctx_2);
          r += '">';
          r += c(ctx_2.data.charge.serviceCharge, ctx_2);
          r += '</span></span>\n                        </div>\n                        <div class="bk-payment-row bk-payment-row-discount">\n                            <span>Discount</span>\n                            <span>-\u20B9<span class="dscnt_amt" data-dscnt_amt="';
          r += c(ctx_2.data.charge.discountAmount, ctx_2);
          r += '">';
          r += c(ctx_2.data.charge.discountAmount, ctx_2);
          r += '</span></span>\n                        </div>\n                        <div class="bk-payment-row" id="gst">\n                            <span>GST on service charge (';
          r += c(ctx_2.data.chargeWithCoupon.gstRate, ctx_2);
          r += '%)</span>\n                            <span>\u20B9<span class="gstAmount" data-gstAmount="';
          r += c(ctx_2.data.charge.gstAmount, ctx_2);
          r += '">';
          r += c(ctx_2.data.charge.gstAmount, ctx_2);
          r += '</span></span>\n                        </div>\n                        <div class="bk-payment-total">\n                            <span>Total</span>\n                            <span class="bk-payment-total-value">\u20B9<span class="totalAmnt" data-totalAmnt="';
          r += c(ctx_2.data.charge.TotalCharge, ctx_2);
          r += '">';
          r += c(ctx_2.data.charge.TotalCharge, ctx_2);
          r += '</span></span>\n                        </div>\n                        ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.data.charge.fee == 0', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                        <div class="bk-fee-note"><sup class="bk-fee-mark">*</sup> Appointment fee is payable at the doctor\'s clinic.</div>\n                        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                    </div>\n                </section>\n                ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n                <div class="bk-bottom-spacer"></div>\n            </form>\n\n            <!-- Sticky bottom action bar -->\n            <div class="bk-action-bar">\n                <div class="bk-action-summary">\n                    <div class="bk-action-label">Total payable</div>\n                    <div class="bk-action-total">\u20B9<span class="bk-action-total-value">';
      r += Template7Helpers.if.call(ctx_1, ctx_1.data.isPromoCouponApplyed, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += c(ctx_2.data.chargeWithCoupon.TotalCharge, ctx_2);
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += c(ctx_2.data.charge.TotalCharge, ctx_2);
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</span></div>\n                </div>\n                <button class="bk-action-btn" type="button" id="bkPayBtn">\n                    <span>';
      r += Template7Helpers.js_if.call(ctx_1, 'this.data.charge.TotalCharge > 0', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'Pay now';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += 'Confirm booking';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</span>\n                    <i class="icon f7-icons if-not-md">arrow_right</i>\n                    <i class="icon material-icons md-only">arrow_forward</i>\n                </button>\n            </div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  style: `
[data-f7-cddde27bc7] .booking-form-page { background: var(--mdoc-bg); }
[data-f7-cddde27bc7] .booking-form-page .page-content { background: var(--mdoc-bg); padding-bottom: 0; }
[data-f7-cddde27bc7] .bk-form { padding: 14px 14px 0; }
[data-f7-cddde27bc7] .bk-hidden { display: none !important; }

    /* Doctor hero card */
[data-f7-cddde27bc7] .bk-doctor-card {
        position: relative;
        display: flex;
        align-items: center;
        gap: 14px;
        padding: 16px;
        background: linear-gradient(160deg, var(--mdoc-green-soft) 0%, var(--mdoc-blue-soft) 100%);
        border: 1px solid rgba(46, 182, 125, 0.18);
        border-radius: 18px;
        overflow: hidden;
        margin-bottom: 16px;
    }
    /* Verified chip on hero: sits on the pastel gradient — use white pill */
[data-f7-cddde27bc7] .bk-doctor-info .doctor-verified-chip {
        background: var(--mdoc-white);
        border-color: rgba(46, 182, 125, 0.30);
        box-shadow: 0 1px 3px rgba(15, 31, 46, 0.04);
    }
[data-f7-cddde27bc7] .bk-doctor-blob {
        position: absolute;
        top: -30px;
        right: -30px;
        width: 130px;
        height: 130px;
        background: radial-gradient(circle, rgba(255,255,255,0.55) 0%, rgba(255,255,255,0) 70%);
        border-radius: 50%;
        pointer-events: none;
    }
[data-f7-cddde27bc7] .bk-doctor-photo {
        position: relative;
        width: 64px;
        height: 64px;
        flex-shrink: 0;
        z-index: 1;
    }
[data-f7-cddde27bc7] .bk-doctor-photo img {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        object-fit: cover;
        background: var(--mdoc-white);
        border: 2px solid var(--mdoc-white);
        box-shadow: 0 2px 8px rgba(15, 31, 46, 0.10);
    }
[data-f7-cddde27bc7] .bk-doctor-badge {
        position: absolute;
        bottom: -3px;
        right: -3px;
        width: 26px;
        height: 26px;
        background: var(--mdoc-white);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 1px 4px rgba(15, 31, 46, 0.18);
        padding: 2px;
        box-sizing: border-box;
    }
[data-f7-cddde27bc7] .bk-doctor-badge img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: contain;
    }
[data-f7-cddde27bc7] .bk-doctor-info { flex: 1; min-width: 0; position: relative; z-index: 1; }
[data-f7-cddde27bc7] .bk-doctor-name {
        font-size: 16px;
        font-weight: 800;
        color: var(--mdoc-ink);
        line-height: 1.2;
        letter-spacing: -0.2px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
[data-f7-cddde27bc7] .bk-doctor-degree {
        font-size: 12.5px;
        color: var(--mdoc-muted);
        margin-top: 3px;
        line-height: 1.3;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
[data-f7-cddde27bc7] .bk-doctor-address {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        margin-top: 6px;
        padding: 3px 9px;
        background: var(--mdoc-white);
        border-radius: 100px;
        font-size: 11px;
        color: var(--mdoc-blue-dark);
        font-weight: 600;
        max-width: 100%;
    }
[data-f7-cddde27bc7] .bk-doctor-address .icon {
        color: var(--mdoc-blue-dark);
        font-size: 12px;
        flex-shrink: 0;
    }
[data-f7-cddde27bc7] .bk-doctor-address span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        min-width: 0;
    }

    /* Sections */
[data-f7-cddde27bc7] .bk-section { margin-bottom: 16px; }
[data-f7-cddde27bc7] .bk-section-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 4px 8px;
    }
[data-f7-cddde27bc7] .bk-section-title {
        font-size: 13px;
        font-weight: 700;
        color: var(--mdoc-ink);
        letter-spacing: -0.1px;
    }
[data-f7-cddde27bc7] .bk-section-optional {
        font-size: 11px;
        font-weight: 600;
        color: var(--mdoc-muted);
    }
[data-f7-cddde27bc7] .bk-section-card {
        background: var(--mdoc-white);
        border: 1px solid var(--mdoc-border);
        border-radius: 14px;
        padding: 14px;
    }

    /* Appointment type pill toggle */
[data-f7-cddde27bc7] .bk-type-row {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px;
    }
[data-f7-cddde27bc7] .bk-type-pill {
        position: relative;
        display: block;
        cursor: pointer;
    }
[data-f7-cddde27bc7] .bk-type-pill input[type="radio"] {
        position: absolute;
        opacity: 0;
        width: 0;
        height: 0;
        pointer-events: none;
    }
[data-f7-cddde27bc7] .bk-type-pill-body {
        display: flex;
        flex-direction: column;
        padding: 12px 14px;
        background: var(--mdoc-white);
        border: 1px solid var(--mdoc-border);
        border-radius: 14px;
        transition: background .15s ease, border-color .15s ease;
    }
[data-f7-cddde27bc7] .bk-type-pill-title {
        font-size: 14px;
        font-weight: 700;
        color: var(--mdoc-ink);
        line-height: 1.2;
    }
[data-f7-cddde27bc7] .bk-type-pill-sub {
        font-size: 11px;
        color: var(--mdoc-muted);
        margin-top: 3px;
        line-height: 1.3;
    }
[data-f7-cddde27bc7] .bk-type-pill input[type="radio"]:checked + .bk-type-pill-body {
        background: var(--mdoc-green-soft);
        border-color: var(--mdoc-green);
    }
[data-f7-cddde27bc7] .bk-type-pill input[type="radio"]:checked + .bk-type-pill-body .bk-type-pill-title {
        color: var(--mdoc-green-dark);
    }

    /* Date tile strip */
[data-f7-cddde27bc7] .bk-date-card { padding: 12px 0; }
[data-f7-cddde27bc7] .bk-date-swiper { padding: 0 14px; }
[data-f7-cddde27bc7] .bk-date-tile {
        width: 64px !important;
        background: var(--mdoc-white);
        border: 1px solid var(--mdoc-border);
        border-radius: 14px;
        padding: 10px 6px;
        text-align: center;
        cursor: pointer;
        transition: background .15s ease, border-color .15s ease, transform .15s ease;
    }
[data-f7-cddde27bc7] .bk-date-tile:active { transform: scale(0.97); }
[data-f7-cddde27bc7] .bk-date-tile-day {
        font-size: 10px;
        font-weight: 700;
        color: var(--mdoc-muted);
        text-transform: uppercase;
        letter-spacing: 0.4px;
        line-height: 1.2;
    }
[data-f7-cddde27bc7] .bk-date-tile-date {
        font-size: 20px;
        font-weight: 800;
        color: var(--mdoc-ink);
        line-height: 1;
        margin: 4px 0 2px;
        letter-spacing: -0.5px;
    }
[data-f7-cddde27bc7] .bk-date-tile-month {
        font-size: 10px;
        font-weight: 700;
        color: var(--mdoc-muted);
        text-transform: uppercase;
        letter-spacing: 0.3px;
    }
[data-f7-cddde27bc7] .bk-date-tile.active {
        background: var(--mdoc-green);
        border-color: var(--mdoc-green);
        box-shadow: 0 4px 12px rgba(46, 182, 125, 0.25);
    }
    .bk-date-tile.active .bk-date-tile-day,
    .bk-date-tile.active .bk-date-tile-date,
[data-f7-cddde27bc7] .bk-date-tile.active .bk-date-tile-month {
        color: var(--mdoc-white);
    }
[data-f7-cddde27bc7] .bk-date-tile.inactive {
        background: var(--mdoc-bg);
        opacity: 0.5;
        cursor: not-allowed;
    }
    .bk-date-tile.inactive .bk-date-tile-date,
    .bk-date-tile.inactive .bk-date-tile-day,
[data-f7-cddde27bc7] .bk-date-tile.inactive .bk-date-tile-month {
        color: var(--mdoc-muted);
    }

    /* Time slot grid */
[data-f7-cddde27bc7] .bk-slots-card { padding: 10px 6px; }
[data-f7-cddde27bc7] .bk-slot-grid {
        list-style: none;
        margin: 0;
        padding: 0;
        display: flex;
        flex-wrap: wrap;
    }
[data-f7-cddde27bc7] .bk-slot-grid > .col-50 {
        width: 50%;
        padding: 4px;
        box-sizing: border-box;
    }
[data-f7-cddde27bc7] .bk-slot {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 38px;
        background: var(--mdoc-white);
        border: 1px solid var(--mdoc-border);
        border-radius: 100px;
        font-size: 12.5px;
        font-weight: 600;
        color: var(--mdoc-ink);
        cursor: pointer;
        transition: background .15s ease, color .15s ease, border-color .15s ease;
        list-style: none;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 0 8px;
    }
[data-f7-cddde27bc7] .bk-slot.active {
        background: var(--mdoc-green);
        color: var(--mdoc-white);
        border-color: var(--mdoc-green);
        box-shadow: 0 2px 8px rgba(46, 182, 125, 0.22);
    }
[data-f7-cddde27bc7] .bk-slot:not(.active):active {
        background: var(--mdoc-green-soft);
        border-color: var(--mdoc-green);
        color: var(--mdoc-green-dark);
    }

    /* Patient form */
[data-f7-cddde27bc7] .bk-patient-card { padding: 10px 12px 14px; }
[data-f7-cddde27bc7] .bk-patient-form {
        padding: 0;
        gap: 12px;
    }
[data-f7-cddde27bc7] .bk-form-row {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px;
    }
[data-f7-cddde27bc7] .bk-form-row > .pl-form-field { min-width: 0; }
[data-f7-cddde27bc7] .bk-form-row > .pl-form-field input { min-width: 0; }
    /* Reuse pl-form-field styles from app.css for inputs */

    /* Patient tile list (Free type) */
[data-f7-cddde27bc7] .bk-patient-list {
        display: flex;
        flex-direction: column;
    }
[data-f7-cddde27bc7] .bk-patient-tile {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px 4px;
        border-bottom: 1px solid var(--mdoc-border);
        cursor: pointer;
    }
[data-f7-cddde27bc7] .bk-patient-tile:last-child { border-bottom: none; }
[data-f7-cddde27bc7] .bk-patient-tile input[type="radio"] {
        position: absolute;
        opacity: 0;
        width: 0;
        height: 0;
        pointer-events: none;
    }
[data-f7-cddde27bc7] .bk-patient-tile-radio {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        border: 2px solid var(--mdoc-border);
        background: var(--mdoc-white);
        flex-shrink: 0;
        position: relative;
        transition: border-color .15s ease;
    }
[data-f7-cddde27bc7] .bk-patient-tile-radio::after {
        content: "";
        position: absolute;
        inset: 4px;
        border-radius: 50%;
        background: var(--mdoc-green);
        transform: scale(0);
        transition: transform .15s ease;
    }
[data-f7-cddde27bc7] .bk-patient-tile input[type="radio"]:checked + .bk-patient-tile-radio {
        border-color: var(--mdoc-green);
    }
[data-f7-cddde27bc7] .bk-patient-tile input[type="radio"]:checked + .bk-patient-tile-radio::after {
        transform: scale(1);
    }
[data-f7-cddde27bc7] .bk-patient-tile-body { flex: 1; min-width: 0; }
[data-f7-cddde27bc7] .bk-patient-tile-name {
        font-size: 14px;
        font-weight: 700;
        color: var(--mdoc-ink);
        line-height: 1.2;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
[data-f7-cddde27bc7] .bk-patient-tile-meta {
        font-size: 12px;
        color: var(--mdoc-muted);
        margin-top: 3px;
    }

    /* Coupon */
[data-f7-cddde27bc7] .bk-coupon-apply {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px 14px;
        background: var(--mdoc-white);
        border: 1px dashed var(--mdoc-green);
        border-radius: 14px;
        text-decoration: none;
        color: var(--mdoc-ink);
    }
[data-f7-cddde27bc7] .bk-coupon-apply-icon {
        width: 38px;
        height: 38px;
        border-radius: 50%;
        background: var(--mdoc-green-soft);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }
[data-f7-cddde27bc7] .bk-coupon-apply-icon .icon { color: var(--mdoc-green-dark); font-size: 18px; }
[data-f7-cddde27bc7] .bk-coupon-apply-body { flex: 1; min-width: 0; }
[data-f7-cddde27bc7] .bk-coupon-apply-title {
        font-size: 14px;
        font-weight: 700;
        color: var(--mdoc-green-dark);
        line-height: 1.2;
    }
[data-f7-cddde27bc7] .bk-coupon-apply-sub {
        font-size: 11.5px;
        color: var(--mdoc-muted);
        margin-top: 3px;
    }
[data-f7-cddde27bc7] .bk-coupon-apply-arrow { color: var(--mdoc-green-dark); font-size: 20px; flex-shrink: 0; }

[data-f7-cddde27bc7] .bk-coupon-applied {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px 14px;
        background: var(--mdoc-green-soft);
        border: 1px solid rgba(46, 182, 125, 0.30);
        border-radius: 14px;
    }
[data-f7-cddde27bc7] .bk-coupon-applied-icon {
        width: 38px;
        height: 38px;
        border-radius: 50%;
        background: var(--mdoc-white);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }
[data-f7-cddde27bc7] .bk-coupon-applied-icon .icon { color: var(--mdoc-green-dark); font-size: 20px; }
[data-f7-cddde27bc7] .bk-coupon-applied-body { flex: 1; min-width: 0; }
[data-f7-cddde27bc7] .bk-coupon-applied-code {
        font-size: 14px;
        font-weight: 800;
        color: var(--mdoc-ink);
        letter-spacing: 0.5px;
        line-height: 1.2;
    }
[data-f7-cddde27bc7] .bk-coupon-applied-saved {
        font-size: 12px;
        color: var(--mdoc-green-dark);
        font-weight: 600;
        margin-top: 3px;
    }
[data-f7-cddde27bc7] .bk-coupon-applied-remove {
        font-size: 11px;
        font-weight: 800;
        color: #C2570A;
        background: var(--mdoc-white);
        padding: 5px 10px;
        border-radius: 100px;
        text-transform: uppercase;
        letter-spacing: 0.4px;
        cursor: pointer;
        flex-shrink: 0;
    }

    /* Payment summary card */
[data-f7-cddde27bc7] .bk-payment-card { padding: 4px 14px; }
[data-f7-cddde27bc7] .bk-payment-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0;
        border-bottom: 1px solid var(--mdoc-border);
        font-size: 13.5px;
        color: var(--mdoc-muted);
    }
[data-f7-cddde27bc7] .bk-payment-row span:last-child {
        color: var(--mdoc-ink);
        font-weight: 600;
    }
[data-f7-cddde27bc7] .bk-payment-row-discount span:last-child { color: var(--mdoc-green-dark); }
[data-f7-cddde27bc7] .bk-payment-total {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 0;
        font-size: 15px;
        font-weight: 700;
        color: var(--mdoc-ink);
    }
[data-f7-cddde27bc7] .bk-payment-total-value {
        font-size: 18px;
        font-weight: 800;
        color: var(--mdoc-green-dark);
        letter-spacing: -0.3px;
    }
[data-f7-cddde27bc7] .bk-fee-note {
        font-size: 11px;
        color: var(--mdoc-muted);
        padding: 0 0 12px;
        line-height: 1.45;
    }
[data-f7-cddde27bc7] .bk-fee-mark { color: #E0573A; font-size: 10px; }

    /* Sticky bottom action bar */
[data-f7-cddde27bc7] .bk-bottom-spacer { height: 92px; }
[data-f7-cddde27bc7] .bk-action-bar {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px 14px calc(12px + env(safe-area-inset-bottom));
        background: var(--mdoc-white);
        border-top: 1px solid var(--mdoc-border);
        box-shadow: 0 -4px 14px rgba(15, 31, 46, 0.06);
        z-index: 50;
    }
[data-f7-cddde27bc7] .bk-action-summary {
        flex: 1 1 auto;
        min-width: 0;
        overflow: hidden;
    }
[data-f7-cddde27bc7] .bk-action-label {
        font-size: 11px;
        font-weight: 600;
        color: var(--mdoc-muted);
        letter-spacing: 0.2px;
        line-height: 1.1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
[data-f7-cddde27bc7] .bk-action-total {
        font-size: 19px;
        font-weight: 800;
        color: var(--mdoc-ink);
        letter-spacing: -0.4px;
        margin-top: 2px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
[data-f7-cddde27bc7] .bk-action-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        padding: 0 18px;
        height: 44px;
        flex: 0 0 auto;
        background: var(--mdoc-green);
        color: var(--mdoc-white);
        border: none;
        border-radius: 100px;
        font-size: 14px;
        font-weight: 700;
        cursor: pointer;
        transition: background .15s ease, transform .15s ease;
        box-shadow: 0 4px 12px rgba(46, 182, 125, 0.25);
        white-space: nowrap;
    }
[data-f7-cddde27bc7] .bk-action-btn:active { background: var(--mdoc-green-dark); transform: scale(0.97); }
[data-f7-cddde27bc7] .bk-action-btn .icon { font-size: 16px; color: var(--mdoc-white); }
`,
  styleScoped: true
};
    